import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
import { CountdownClock } from './CountdownClock';
const reassurances = ['El pago es único · Sin suscripción', '100% PDF · enviado a tu email', 'Garantía de satisfacción de 7 días'];
export function FinalSection() {
  return <section className="bg-ink text-cream" data-id="element-76" data-mp="330mandtmpmig">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-77" data-mp="2od1419xjp55s">
        <div className="grid gap-14 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-78" data-mp="2obgdrwi9k8dq">
          <div data-id="element-79" data-mp="2t5u9y14r2jjg">
            <Eyebrow tone="light" data-id="element-80" data-mp="2t5kmak76gogx">Cuenta final</Eyebrow>
            <h2 className="mt-4 font-condensed text-4xl uppercase leading-[0.95] tracking-tight sm:text-5xl" data-id="element-81" data-mp="2fdnwimszeqnp">
              Pack completo, precio de esta noche
            </h2>
            <div className="mt-8" data-id="element-82" data-mp="25eyodlqw0kkn">
              <CountdownClock variant="light" data-id="element-83" data-mp="25fzy9mw6310s" />
            </div>
          </div>

          <div className="rounded-2xl border border-cream/15 bg-cream/[0.04] p-8 sm:p-10" data-id="element-84" data-mp="2ae1gk5lrqwb7">
            <p className="text-[11px] font-semibold uppercase tracking-eyebrow text-cream/60" data-id="element-85" data-mp="2wdlikh0aavq3">
              6 volúmenes + 6 bonos gratis
            </p>
            <div className="mt-4 flex flex-wrap items-baseline gap-4" data-id="element-86" data-mp="2rh4lgxb3x70v">
              <span className="font-display text-5xl font-semibold leading-none sm:text-6xl" data-id="element-87" data-mp="35di4iavahghg">
                $27.990
              </span>
              <span className="font-display text-2xl text-cream/45 line-through" data-id="element-88" data-mp="30dvra1fgo08n">$745.000</span>
            </div>
            <p className="mt-3 text-[15px] text-cream/75" data-id="element-89" data-mp="28oiqef80xkhc">Ahorrás $717.010 hoy</p>

            <div className="mt-8" data-id="element-90" data-mp="28mpk511bp29v">
              <CtaButton data-id="element-91" data-mp="2mggsi63big40">¡Sí, quiero ahorrar tiempo y retener más alumnos!</CtaButton>
            </div>

            <ul className="mt-7 space-y-2.5" data-id="element-92" data-mp="2hoyt3mgy0nl5">
              {reassurances.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] text-cream/70" data-id="element-93" data-mp="1tzml2pxcqlkf">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber" data-id="element-94" data-mp="1p0jgf6laahcz" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-20 border-t border-cream/15 pt-14" data-id="element-95" data-mp="3p0yfm8qnw85k">
          <div className="max-w-3xl" data-id="element-96" data-mp="3u0b38vpcxj97">
            <Eyebrow tone="light" data-id="element-97" data-mp="2n81qva1ym8s">Para cerrar</Eyebrow>
            <h2 className="mt-4 font-condensed text-5xl uppercase leading-[0.92] tracking-tight sm:text-6xl" data-id="element-98" data-mp="2oj9152pic4n">
              El reloj corre.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-cream/75" data-id="element-99" data-mp="3646r9kw9j2un">
              Mañana podés volver a pasar horas buscando fichas… o podés tener todo tu año de
              material listo en los próximos 60 segundos.
            </p>
            <p className="mt-4 text-base leading-relaxed text-cream/75" data-id="element-100" data-mp="3g1bc9hedgs9v">
              Pasaste años dominando tu instrumento. Merecés un sistema de enseñanza a la altura de
              tu música.
            </p>
            <p className="mt-8 font-display text-2xl italic leading-snug text-cream sm:text-3xl" data-id="element-101" data-mp="vbm23hom5uni">
              Basta de la corrida del domingo. Empezá con el sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
}